<script>
    export let color = 'currentColor'
    export let size = 56
    export let gap = 12
    export let duration = 1

    let style = `
		--loader-size: ${size}px;
		--loader-color: ${color};
		--loader-animation-duration: ${duration}s;
		--loader-gap: ${gap}px;
	`
</script>

<style lang="scss">div {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  box-shadow: 0 10px 0 var(--loader-color);
  position: relative;
  animation: loader-uyqn2q5 0.5s ease-in-out alternate infinite;
  animation-delay: 0.2s;
  top: -8px;
}
div::after, div::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  box-shadow: 0 10px 0 var(--loader-color);
  animation: loader-uyqn2q5 0.5s cubic-bezier(0.42, 0, 0.35, 0.89) alternate infinite;
}
div::before {
  left: -8px;
  animation-delay: 0.3s;
}
div::after {
  right: -8px;
  animation-delay: 0.1s;
}
@keyframes loader-uyqn2q5 {
  0% {
    box-shadow: 0 10px 0 var(--loader-color);
  }
  100% {
    box-shadow: 0 5px 0 var(--loader-color);
  }
}
/*# sourceMappingURL=src/components/Loader.svelte.map */</style>

<div {style} />